function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

import { LOADING, SUCCESS, ERROR, CLEAR_SEARCH, LIVE, RESULT_STATS_GEOGRAPHY, RESULT_STATS_TIME, CLEAR_WARNING, CLEAR_ERROR } from './actions';
var initialStateStats = {
  loading: false,
  data: null
};
export var initialState = {
  loading: false,
  form: null,
  submittedForm: null,
  liveForm: null,
  data: null,
  statsGeography: initialStateStats,
  statsTime: initialStateStats,
  warnings: null,
  error: null
};
export var formReducer = function formReducer(state, action) {
  switch (action.type) {
    case LOADING:
      return {
        loading: true,
        form: state.form,
        submittedForm: action.form,
        liveForm: action.form,
        // The sender can request the form data to change
        data: state.data,
        statsGeography: {
          loading: true,
          data: state.statsGeography !== null ? state.statsGeography.data : null
        },
        statsTime: {
          loading: true,
          data: state.statsTime !== null ? state.statsTime.data : null
        },
        warnings: null,
        error: null
      };

    case SUCCESS:
      return {
        loading: false,
        form: action.form,
        submittedForm: state.submittedForm,
        liveForm: state.liveForm,
        data: action.data,
        statsGeography: state.statsGeography,
        statsTime: state.statsTime,
        warnings: action.warnings,
        error: null
      };

    case RESULT_STATS_GEOGRAPHY:
      return _objectSpread(_objectSpread({}, state), {}, {
        statsGeography: action.form === state.submittedForm ? {
          loading: false,
          data: action.statsGeography
        } : state.statsGeography
      });

    case RESULT_STATS_TIME:
      return _objectSpread(_objectSpread({}, state), {}, {
        statsTime: action.form === state.submittedForm ? {
          loading: false,
          data: action.statsTime
        } : state.statsTime
      });

    case ERROR:
      return {
        loading: false,
        form: state.form,
        submittedForm: state.submittedForm,
        liveForm: state.liveForm,
        data: null,
        statsGeography: state.statsGeography,
        statsTime: state.statsTime,
        warnings: null,
        error: action.error
      };

    case CLEAR_SEARCH:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        form: {
          resultsPerPage: state.resultsPerPage // Preserve this parameter

        }
      });

    case LIVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        liveForm: action.liveForm
      });

    case CLEAR_WARNING:
      return _objectSpread(_objectSpread({}, state), {}, {
        warnings: null
      });

    case CLEAR_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null
      });

    default:
      return state;
  }
};